import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MuscleGroup } from 'src/models/muscle-group.model';
import { MuscleGroupService } from 'src/services/muscle-group.service';

@Component({
    selector: 'app-exercise-filter',
    templateUrl: './exercise-filter.component.html',
    styleUrls: ['./exercise-filter.component.scss'],
    standalone: false
})
export class ExerciseFilterComponent implements OnInit, OnDestroy {
  toggleStates = new Map<string, boolean>();
  private destroy$ = new Subject<void>();
  muscleGroups: MuscleGroup[] = [];
  @Output() toggleStatesChange = new EventEmitter<Map<string, boolean>>();

  constructor(private muscleGroupService: MuscleGroupService) {}

  ngOnInit() {
    this.muscleGroupService
      .getMuscleGroups()
      .pipe(takeUntil(this.destroy$))
      .subscribe((groups) => {
        this.muscleGroups = groups;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleChip(group: string) {
    // Check if the group is already in the map
    const currentState = this.toggleStates.get(group);

    // Update the map with the toggled state
    this.toggleStates.set(group, !currentState);
  }

  toggleChipGroup(muscleGroup: MuscleGroup) {
    const currentState = this.toggleStates.get(muscleGroup.group);
    this.toggleStates.set(muscleGroup.group, !currentState);
    this.toggleStatesChange.emit(this.toggleStates); // Emit the updated map
  }
}
